// extracted by mini-css-extract-plugin
export default {"container":"container_container__srhc2"};